import { render, staticRenderFns } from "./UpgradePlanButton.vue?vue&type=template&id=ca5b529a"
import script from "./UpgradePlanButton.vue?vue&type=script&lang=js"
export * from "./UpgradePlanButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca5b529a')) {
      api.createRecord('ca5b529a', component.options)
    } else {
      api.reload('ca5b529a', component.options)
    }
    module.hot.accept("./UpgradePlanButton.vue?vue&type=template&id=ca5b529a", function () {
      api.rerender('ca5b529a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pro-option-wrapper/UpgradePlanButton.vue"
export default component.exports